/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import TopPomGroupBar from './TopPomGroupBar';
import PomLibraryTable from './PomLibraryTable';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import TableView from './TableView';
import * as action from '../../Store/Pom.action';
import { usePOMGroupState } from './PomGroupContext';
import ImgDropzone from '../../../../../Components/ImgDropzone/ImgDropzone';
import ConfirmationPopup from '../../../../../Components/ModalPopup/ConfirmationPopup';
import noImage from '../../../../../assets/images/no-image.png';
import CustomTooltip from '../../../../../Components/Tooltip/CustomTooltip';

function PomGroup() {
  const [imageUrl, setImageUrl] = useState(null);
  const [fullImageUrl, setFullImageUrl] = useState(null);
  const { handleSubmitPomGroup, setPomGroupState, pomGroupState } = usePOMGroupState();
  const { showImageUpload } = pomGroupState;
  const history = useHistory();
  const childRef = useRef();
  async function getImageUrl(objectKey) {
    return `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${objectKey}`;
  }
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const resetSpecState = () => {
    setPomGroupState((prev) => ({
      ...prev,
      groupName: '',
      selectCategoryOne: [],
      selectCategoryTwo: [],
      selectCategoryThree: [],
      pomTableData: [],
      selectedPOM: [],
      fullImage: '',
      imageName: '',
    }));
  };
  useEffect(() => {
    return () => {
      resetSpecState();
      dispatch(action.clearReducer());
      dispatch(action.clearAllRecuderRecords());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleImageUpload = () => {
    setPomGroupState((prevState) => ({
      ...prevState,
      showImageUpload: true,
    }));
  };

  const handleImageDelete = () => {
    setPomGroupState((prevState) => ({
      ...prevState,
      showDeleteModal: true,
    }));
  };
  useEffect(() => {
    const fetchImage = async () => {
      if (
        pomGroupState?.image.includes('data:image') ||
        pomGroupState?.image.includes('blob') ||
        pomGroupState?.fullImage.includes('data:image') ||
        pomGroupState?.fullImage.includes('blob')
      ) {
        setImageUrl(pomGroupState?.image);
        setFullImageUrl(pomGroupState?.fullImage);
      } else if (pomGroupState?.image) {
        const image = await getImageUrl(pomGroupState?.image);
        const fullImage = await getImageUrl(pomGroupState?.fullImage);
        setImageUrl(image);
        setFullImageUrl(fullImage);
      } else {
        setImageUrl(noImage);
      }
    };
    fetchImage();
  }, [pomGroupState?.image, pomGroupState?.fullImage]);

  const handleSubmitUpload = async (type) => {
    if (type !== 'close') {
      const croppedFileUrl = await childRef.current.showCroppedImg();
      if (croppedFileUrl) {
        const { imageRes, originalImg, fileObj } = await croppedFileUrl;
        const orignalImageres = await originalImg;

        setPomGroupState((prevData) => ({
          ...prevData,
          showImageUpload: false,

          image: imageRes,
          fullImage: orignalImageres,
          imageName: fileObj.name,
        }));
      } else {
        toasterMsg(t('SPEC_TEMP_LIBRARY.IMAGE_REQUIRED'), 'danger');
      }
    } else {
      setPomGroupState((prevData) => ({
        ...prevData,
        showImageUpload: false,
      }));
    }
  };

  const closeModal = () => {
    setPomGroupState((prevState) => ({
      ...prevState,
      showDeleteModal: false,
    }));
  };

  const confirmDeleteImage = () => {
    setPomGroupState((prevData) => ({
      ...prevData,
      showDeleteModal: false,
      image: '',
      fullImage: '',
      imageName: '',
    }));
  };

  return (
    <div>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="pom-title">
            {t('POM_GROUP.POM_GROUP')} | <span className="d-inline-block">{pomGroupState?.groupName}</span>
          </h4>
        </div>
        {/* <div className=""> */}
        <div className="pom-action-icons">
          <CustomTooltip tooltipText={t('SPEC_TEMP_LIBRARY.UPLOAD_IMAGE')}>
            <button aria-label="upload" className="btn px-2" type="button" onClick={handleImageUpload}>
              <span className="icon-Upload-1 f-28" aria-hidden="true" />
            </button>
          </CustomTooltip>
          <CustomTooltip tooltipText={t('SPEC_TEMP_LIBRARY.REMOVE_IMAGE')}>
            <button aria-label="delete" className="btn px-2" type="button" onClick={handleImageDelete}>
              <span className="icon-Delete f-28" aria-hidden="true" />
            </button>
          </CustomTooltip>
          <CustomTooltip tooltipText={t('COMMON_LABEL.CANCEL')}>
            <button aria-label={t('COMMON_LABEL.CANCEL')} type="button" className="btn px-2" onClick={() => history.push('/libraries/pom-groups')}>
              <i className="icon-close f-20" />
            </button>
          </CustomTooltip>
        </div>
        <figure className="pom-edit-figure ">
          <img width="47" src={imageUrl} alt="croppedImage" />
        </figure>
        {/* </div> */}
        <div className="search-filter floting-actions">
          <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.SAVE')}>
            <button aria-label="Save" type="button" name="Save" className="btn p-0" onClick={handleSubmitPomGroup}>
              <i className="icon-Save-1" />
            </button>
          </CustomTooltip>
        </div>
      </div>
      <TopPomGroupBar />
      <div className="pom-group-list">
        <PomLibraryTable />
        <TableView />
      </div>
      {showImageUpload && (
        <Modal className="common-custom-modal modal-large" show={showImageUpload} backdrop="static">
          <Modal.Header>
            <Modal.Title className="f-24">{t('SPEC_TEMP_LIBRARY.UPLOAD_IMAGE')}</Modal.Title>
            <span onClick={() => handleSubmitUpload('close')} className="icon-close cursor-pointer text-dark text-decoration-none" />
          </Modal.Header>

          <Modal.Body>
            <ImgDropzone
              ref={childRef}
              title={t('POM_GROUP.POM_GROUP_TITLE')}
              onSubmit={handleSubmitUpload}
              image={fullImageUrl}
              acceptedFileExtenstion=".jpeg,.png,.jpg"
            />
          </Modal.Body>
        </Modal>
      )}
      {pomGroupState?.showDeleteModal && (
        <ConfirmationPopup
          onOpen={pomGroupState?.showDeleteModal}
          onConfirm={() => confirmDeleteImage()}
          title={t('SPEC_TEMP_LIBRARY.REMOVE_IMAGE')}
          message={t('SPEC_TEMP_LIBRARY.REMOVE_MESSAGE')}
          toggle={() => closeModal()}
        />
      )}
    </div>
  );
}

export default PomGroup;
